import { Grid } from '@mui/material';
import { useEffect } from 'react';
import { UseFormReturn } from 'react-hook-form';
import { Question, Validation } from 'src/@types/generalEnquete';
import RHFUnRegisterCheckBox from 'src/components/react-hook-form/RHFUnRegisterCheckBox';
import i18n from 'src/locales/i18n';

type Props = {
  methods: UseFormReturn;
  existingQuestion?: Question;
  labelKey: string;
  textQuestionName: string;
};
type Language = 'ja' | 'en';

const DateValidationForm = ({ methods, existingQuestion, labelKey }: Props) => {
  const labelMap: Record<Language, string> = {
    ja: i18n.t(labelKey, { lng: 'ja' }),
    en: i18n.t(labelKey, { lng: 'en' }),
  };
  const lang = i18n.language as Language;

  // isCalendarSyncの初期値を設定する
  useEffect(() => {
    const defaultValue = existingQuestion ? (existingQuestion.validation as Validation).isCalendarSync ?? false : false;

    methods.setValue('isCalendarSync', defaultValue, {
      shouldDirty: false,
    });
  }, [existingQuestion, methods]);

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={12}>
        <RHFUnRegisterCheckBox
          name={'isCalendarSync'}
          control={methods.control}
          label={labelMap[lang]}
          fieldName={[]}
          unregister={methods.unregister}
        />
      </Grid>
    </Grid>
  );
};

export default DateValidationForm;
